export const adjectiveData = [
  { id: 1, korean: "단순한", english: "mere" },
  { id: 2, korean: "광대한", english: "vast" },
  { id: 3, korean: "주요한", english: "prime" },
  { id: 4, korean: "주된", english: "chief" },
  { id: 5, korean: "주요한", english: "main" },
  { id: 6, korean: "가까운", english: "close" },
  { id: 7, korean: "유일한", english: "sole" },
  { id: 8, korean: "확실한", english: "certain" },
  { id: 9, korean: "완전한", english: "complete" },
  { id: 10, korean: "동등한", english: "equal" },
  { id: 11, korean: "가치 있는", english: "worth" },
  { id: 12, korean: "극단적인", english: "extreme" },
  { id: 13, korean: "이른", english: "early" },
  { id: 14, korean: "늦은", english: "late" },
  { id: 15, korean: "이전의", english: "former" },
  { id: 16, korean: "나중의", english: "latter" },
  { id: 17, korean: "현재의", english: "present" },
  { id: 18, korean: "전 세계적인", english: "worldwide" },
  { id: 19, korean: "시계 방향의", english: "clockwise" },
  { id: 20, korean: "반시계 방향의", english: "counterclockwise" },
  { id: 21, korean: "실내의", english: "indoor" },
  { id: 22, korean: "실외의", english: "outdoor" },
  { id: 23, korean: "이용 가능한", english: "available" },
  { id: 24, korean: "저렴한", english: "affordable" },
  { id: 25, korean: "경쟁력 있는", english: "competitive" },
  { id: 26, korean: "일관된", english: "consistent" },
  { id: 27, korean: "상당한", english: "considerable" },
  { id: 28, korean: "자신 있는", english: "confident" },
  { id: 29, korean: "효율적인", english: "efficient" },
  { id: 30, korean: "효과적인", english: "effective" },
  { id: 31, korean: "독점적인", english: "exclusive" },
  { id: 32, korean: "광범위한", english: "extensive" },
  { id: 33, korean: "일시적인", english: "temporary" },
  { id: 34, korean: "영구적인", english: "permanent" },
  { id: 35, korean: "다가오는", english: "upcoming" },
  { id: 36, korean: "초기의", english: "initial" },
  { id: 37, korean: "이전의", english: "previous" },
  { id: 38, korean: "현재의", english: "current" },
  { id: 39, korean: "긴급한", english: "urgent" },
  { id: 40, korean: "빈번한", english: "frequent" },
  { id: 41, korean: "가끔의", english: "occasional" },
  { id: 42, korean: "잠정적인", english: "tentative" },
  { id: 43, korean: "책임 있는", english: "responsible" },
  { id: 44, korean: "신뢰할 수 있는", english: "reliable" },
  { id: 45, korean: "헌신적인", english: "dedicated" },
  { id: 46, korean: "자격이 있는", english: "eligible" },
  { id: 47, korean: "경험이 있는", english: "experienced" },
  { id: 48, korean: "자격을 갖춘", english: "qualified" },
  { id: 49, korean: "능력이 있는", english: "capable" },
  { id: 50, korean: "뛰어난", english: "exceptional" },
  { id: 51, korean: "동기 부여된", english: "motivated" },
  { id: 52, korean: "뛰어난", english: "outstanding" },
  { id: 53, korean: "결함이 있는", english: "defective" },
  { id: 54, korean: "맞춤 제작된", english: "customized" },
  { id: 55, korean: "내구성이 있는", english: "durable" },
  { id: 56, korean: "혁신적인", english: "innovative" },
  { id: 57, korean: "최첨단의", english: "state-of-the-art" },
  { id: 58, korean: "우수한", english: "superior" },
  { id: 59, korean: "다용도의", english: "versatile" },
  { id: 60, korean: "고품질의", english: "high-quality" },
  { id: 61, korean: "사용하기 쉬운", english: "user-friendly" },
  { id: 62, korean: "만족스러운", english: "satisfactory" },
  { id: 63, korean: "금융의", english: "financial" },
  { id: 64, korean: "재정의", english: "fiscal" },
  { id: 65, korean: "수익성이 있는", english: "profitable" },
  { id: 66, korean: "경제적인", english: "economical" },
  { id: 67, korean: "비싼", english: "costly" },
  { id: 68, korean: "합리적인", english: "reasonable" },
  { id: 69, korean: "과도한", english: "excessive" },
  { id: 70, korean: "불충분한", english: "insufficient" },
  { id: 71, korean: "상당한", english: "substantial" },
  { id: 72, korean: "법적인", english: "legal" },
  { id: 73, korean: "유효한", english: "valid" },
  { id: 74, korean: "구속력 있는", english: "binding" },
  { id: 75, korean: "공식적인", english: "official" },
  { id: 76, korean: "기밀의", english: "confidential" },
  { id: 77, korean: "금지된", english: "prohibited" },
  { id: 78, korean: "허가되지 않은", english: "unauthorized" },
  { id: 79, korean: "적용 가능한", english: "applicable" },
  { id: 80, korean: "보류 중인", english: "pending" },
  { id: 81, korean: "규제의", english: "regulatory" },
  { id: 82, korean: "행정의", english: "administrative" },
  { id: 83, korean: "사무의", english: "clerical" },
  { id: 84, korean: "전문적인", english: "professional" },
  { id: 85, korean: "관리의", english: "managerial" },
  { id: 86, korean: "운영의", english: "operational" },
  { id: 87, korean: "원격의", english: "remote" },
  { id: 88, korean: "현장의", english: "on-site" },
  { id: 89, korean: "자동화된", english: "automated" },
  { id: 90, korean: "협력적인", english: "collaborative" },
  { id: 91, korean: "넓은", english: "spacious" },
  { id: 92, korean: "현대적인", english: "modern" },
  { id: 93, korean: "잘 갖춰진", english: "well-equipped" },
  { id: 94, korean: "접근 가능한", english: "accessible" },
  { id: 95, korean: "가구가 비치된", english: "furnished" },
  { id: 96, korean: "수리된", english: "renovated" },
  { id: 97, korean: "편리한", english: "convenient" },
  { id: 98, korean: "저렴한", english: "affordable" },
  { id: 99, korean: "안전한", english: "secure" },
  { id: 100, korean: "홍보의", english: "promotional" },
  { id: 101, korean: "설득력 있는", english: "persuasive" },
  { id: 102, korean: "눈길을 끄는", english: "eye-catching" },
  { id: 103, korean: "전략적인", english: "strategic" },
  { id: 104, korean: "설득력 있는, 강력한", english: "compelling" },
  { id: 105, korean: "널리 퍼진", english: "widespread" },
  { id: 106, korean: "매력적인", english: "appealing" },
  { id: 107, korean: "대상을 특정한", english: "targeted" },
  { id: 108, korean: "즉각 반응하는", english: "responsive" },
  { id: 109, korean: "예의 바른", english: "courteous" },
  { id: 110, korean: "친절한", english: "accommodating" },
  { id: 111, korean: "참을성 있는", english: "patient" },
  { id: 112, korean: "불만족스러운", english: "dissatisfied" },
  { id: 113, korean: "사과하는", english: "apologetic" },
  { id: 114, korean: "신속한", english: "prompt" },
  { id: 115, korean: "도움을 주는", english: "supportive" },
  { id: 116, korean: "사전 대책을 강구하는", english: "proactive" },
  { id: 117, korean: "충성스러운", english: "loyal" },
  { id: 118, korean: "중요한, 의미 있는", english: "significant" },
  { id: 119, korean: "성장하는, 증가하는", english: "growing" },
  { id: 120, korean: "고급의, 진보된", english: "advanced" },
  { id: 121, korean: "복잡한, 정교한", english: "intricate" },
  { id: 122, korean: "비용 효율적인", english: "cost-effective" },
  { id: 123, korean: "지속가능한", english: "sustainable" },
  { id: 124, korean: "패배한", english: "defeated" },
];
